function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCrimpedtobacco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 144",
    d: "M20 7.59A12.41 12.41 0 1 0 32.41 20 12.41 12.41 0 0 0 20 7.59m0 25.79A13.38 13.38 0 1 1 33.38 20 13.38 13.38 0 0 1 20 33.38m-1.19-12.85a4 4 0 0 0 5.74 0 .75.75 0 0 0 0-1.06.72.72 0 0 0-1 0 2.54 2.54 0 0 1-3.68 0 4 4 0 0 0-5.74 0 2.54 2.54 0 0 1-3.68 0 .72.72 0 0 0-1 0 .77.77 0 0 0 0 1.06 4 4 0 0 0 5.74 0 2.56 2.56 0 0 1 3.68 0m7.58 2.81a4 4 0 0 0-2.87 1.22 2.54 2.54 0 0 1-3.68 0 4 4 0 0 0-5.74 0 .79.79 0 0 0 0 1.07.72.72 0 0 0 1 0 2.54 2.54 0 0 1 3.68 0 4 4 0 0 0 5.74 0 2.54 2.54 0 0 1 3.68 0 .72.72 0 0 0 1 0 .77.77 0 0 0 0-1.07 4 4 0 0 0-2.87-1.22m-11.26-7.9a2.54 2.54 0 0 1 3.68 0 4 4 0 0 0 5.74 0 2.54 2.54 0 0 1 3.68 0 .72.72 0 0 0 1 0 .77.77 0 0 0 0-1.07 4 4 0 0 0-5.74 0 2.54 2.54 0 0 1-3.68 0 4 4 0 0 0-5.74 0 .79.79 0 0 0 0 1.07.72.72 0 0 0 1 0",
    style: {
      fill: "#5e5e5d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCrimpedtobacco);
export default __webpack_public_path__ + "static/media/icn-crimpedtobacco.43fed92f4cc26ee43d297b4e3e2c3d94.svg";
export { ForwardRef as ReactComponent };